<!-- Content -->
<div class="content container-fluid">
  <!-- Page Header -->
  <header class="page-header">
    <nav attr.aria-label="{{ 'wcag.breadcrumb' | translate }}">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a class="breadcrumb-link" routerLink="/operation-internal-events"
            >{{
              'operationInternalEventModule.operationInternalEvents' | translate
            }}
          </a>
        </li>
      </ol>
    </nav>

    <div class="page-header-grid grid-sm">
      <h1 class="page-header-title" id="operationInternalEvents">
        {{ 'operationInternalEventModule.operationInternalEvents' | translate }}
      </h1>

      <div>
        <button
          type="button"
          class="btn btn-primary"
          (click)="onClickCreate()"
          [canSee]="[accessRights.OperationInternalEvents_write]"
        >
          {{ 'general.create' | translate }}
        </button>
      </div>
    </div>
  </header>
  <!-- End Page Header -->

  <div class="w-100">
    <section class="card" aria-labelledby="operationInternalEvents">
      <operation-internal-event-table
        [tableData]="operationInternalEvents$ | async"
        (onBulkAction)="onBulkAction($event)"
        (onClickRow)="onClickRow($event)"
      ></operation-internal-event-table>
    </section>
  </div>
</div>
